

const footer = () => {
  return (
    <div className='w-full h-[125px] md:h-[100px] pt-20 '>
      <div className='text-black flex flex-col pt-5 md:pt-2 md:flex-col justify-start md:items-left h-24 max-w-[1240px] mx-auto px-4 font-Poppins border-t border-gray-300' >
        <h1 className='w-full md:w-auto text-3xl font-bold'>.andrew</h1>
        <p className='text-xs text-gray-500 md:mt-0'>v 91525</p>
      </div>
    </div>
  )
}

export default footer